import React, { useState } from 'react'

function ContactUs() {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const redirectToHome = () => {
        setIsSubmitted(false);
        setIsLoading(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData(event.target);
            const response = await fetch(
                'https://docs.google.com/forms/d/e/1FAIpQLSe-youPYdccsdcscx90RSBMrUox5t8Fyf2omPQXeDhsGb6j3EEw8xXy9Q/formResponse',
                {
                    method: 'POST',
                    body: formData,
                    mode: 'no-cors'
                }
            );
            console.log(response);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div id='contact' className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#f5f7fa] to-[#e8eaf6] p-4">
                <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-2xl border border-gray-100">
                    {!isSubmitted ? (
                        <div>
                            <h2 className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] mb-4">
                                Get in Touch
                            </h2>
                            <p className="text-center text-black mb-6 text-sm tracking-wide">
                                Reach out to us by submitting your queries
                            </p>

                            <form onSubmit={handleSubmit} className="space-y-3">
                                <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        name="entry.338508354"
                                        className="w-full px-4 py-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e00a7e] transition duration-200 ease-in-out shadow-sm hover:shadow-md peer"
                                        required
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 peer-focus:text-[#e00a7e] transition-colors"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>
                                <div className="relative">
                                    <input
                                        type="email"
                                        placeholder="Email Address"
                                        name="entry.1101653039"
                                        className="w-full px-4 py-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e00a7e] transition duration-200 ease-in-out shadow-sm hover:shadow-md peer"
                                        required
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 peer-focus:text-[#e00a7e] transition-colors"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <div className="relative">
                                    <textarea
                                        placeholder="Your Query"
                                        name="entry.1711163296"
                                        className="w-full px-4 py-3 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#e00a7e] transition duration-200 ease-in-out shadow-sm hover:shadow-md resize-none peer"
                                        rows="4"
                                        required
                                    ></textarea>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute left-3 top-4 w-5 h-5 text-gray-400 peer-focus:text-[#e00a7e] transition-colors"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                    </svg>
                                </div>
                                <button
                                    type="submit"
                                    className="w-full flex items-center justify-center px-4 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] rounded-lg  transform transition-all duration-300 hover:scale-[1.02]"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <span>Submitting...</span>
                                    ) : (
                                        <>
                                            Send your message
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>
                    ) : (
                        <div className="p-8 text-center">
                            <div className="mb-6">
                                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">Thank You for Reaching Out!</h2>
                                <p className="text-gray-600 text-sm">
                                    We have received your request and appreciate you contacting us. Our team will get back to you shortly.
                                </p>
                            </div>
                            <button
                                onClick={redirectToHome}
                                className="bg-gradient-to-r from-[#7b45ef] to-[#e2228c] text-white py-2 px-6 rounded-full hover:opacity-90 transition-colors"
                            >
                                Return to Home
                            </button>
                        </div>
                    )}
                    <div className="text-center mt-6 text-xs text-black">
                        Your privacy is important to us. We'll never share your information.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactUs
